const S = {
  //screen-width
  desktop: '1280px',
  tablet: '768px',
  phone: '480px',

  //fonts
  primaryFont: '"Sora", sans-serif',

  lightFont: 300,
  normalFont: 400,
  mediumFont: 500,
  boldFont: 700,
  blackFont: 900,

  //colors
  ////////text
  mainBlackText: '#515151',
  mainGreyText: '#9B9B9B',
  secondaryGreyText: '#939393',
  cardGreyText: '#A6A6A6',
  hoverLink: '#EF8383',
  redText: '#DF8181',
  redTextHover: '#D66060',
  goldenText: '#B58C67',
  footerGreyText: '#4F4F4F',

  ////////buttons
  pairedButton: '#95A8C6',
  pairedButtonHover: '#CDD7E9',
  pairedButtonDisabled: '#F1F5FA',
  defaultPrimaryButton: '#E8E8E8',
  hoverBlack: '#3A3A3A',
  hoverWhite: '#B4B4B4',

  ////////border
  mainBorder: '#C8C8C8',
  secondaryBorder: '#E5E5E5',
  disabledBorder: '#E1E1E1',

  ////////svg
  iconsColor: '#a8a8a8',
  iconsColorHover: '#515151',

  ////////background
  mainBg: '#F5F5F5',
  greyBg: '#E1E1E1',
  hoverGreyBg: '#EFEFEF',
  secondaryGreyBg: '#E8E8E8',
  accentGrey: '#DAE6F8',
  accentBlue: '#61748F',
  accentGold: '#D4AE8B',
  hoverGold: '#D2A67D',
  featuresIcons: '#F0DFCF',
  activeIndicator: '#515151',
  inactiveIndicator: '#DBDBDB',
  lightRedBg: '#DC7878',
  lightGreenBg: '#9EB895',
  greenBg: '#ACDAB6',

  //labels
  redLabel: '#DF8181',
  blueLabel: '#819CDF',
  purpleLabel: '#AA8ECE',
  greenLabel: '#88C08E',
  orangeLabel: '#E4AA89',

  ////////stroke

  categoriesIcon: '#61748F',

  ///////overlay
  overlay: 'rgba(39, 39, 39, 0.2)',

  //////gradients
  // MainMenuRadial:
  //   'ellipse at 10% -36%,rgba(0,0,0,0.9),rgba(0,0,0,0.95) 50%,rgba(0,0,0,0.8) 75%,rgba(0,0,0,0.9) 100%',
  // MainMenuRadialLight:
  //   'ellipse at 10% -36%,rgba(255,255,255,0.6),rgba(255,255,255,0.65) 50%,rgba(255,255,255,0.4) 75%,rgba(255,255,255,0.6) 100%',

  //shadows
  logoShade: '0px 5px 10px rgba(0, 0, 0, 0.4)',
  recentsCardShade: '0px 0px 10px rgba(156, 156, 156, 0.25)',
  recentsCardHoverShade: '0px 3px 15px rgba(152, 152, 152, 0.5)',
  controlsShade: '0px 8px 16px rgba(0, 0, 0, 0.2)',
  brockerCardShade: '0 0 10px 0 rgba(156, 156, 156, 0.25)',
  socialsShade: '0 0 4px 0 rgba(163, 163, 163, 0.25)',
  userCardShade: '0 4px 7px rgba(232, 232, 232, 0.25)',

  //transition properties
  trFast: '250ms cubic-bezier(0.4, 0, 0.2, 1)',
  trSlow: '1s cubic-bezier(0.4, 0, 0.2, 1)',
  trBounce: '250ms cubic-bezier(0.4, 2.08, 0.55, 0.44)',
  trOverflowFast: '250ms cubic-bezier(0.53, 1.79, 0.68, 1.68)',
};

export default S;
